/**
 * Kwoty w formularzach: złote wpisane przez człowieka i grosze w API.
 * Wspólne dla konfiguracji płac i granic nadgodzin z ryczałtami (fala 7b,
 * grupa 9) — jedna reguła zapisu przecinka i spacji tysięcy.
 */

/** „1 234,50" → 123450; puste albo nieliczbowe → `null`. */
export function zlotyToGr(value: string): number | null {
  const normalized = value.trim().replaceAll(' ', '').replaceAll(' ', '').replace(',', '.')
  if (normalized === '') return null
  const parsed = Number(normalized)
  if (!Number.isFinite(parsed)) return null
  return Math.round(parsed * 100)
}

/** 123450 → „1234,50"; `null` → pole puste. */
export function grToZloty(gr: number | null): string {
  if (gr === null) return ''
  return (gr / 100).toFixed(2).replace('.', ',')
}
